module.exports = import("https://kit.fontawesome.com/075922b03a.js");;